import { render as toPlainText } from "datocms-structured-text-to-plain-text"
import { isHeading, isLink } from "datocms-structured-text-utils"
import React from "react"
import { renderNodeRule, StructuredText } from "react-datocms"

import {
  datoInlineLink,
  datoParagraph,
} from "../../dato-components/structured-text-with-link/utils"
import Header from "../../design-system/header"
import UniversalLink from "../../design-system/universal-link"
import { handleAnchorLink } from "../../utils/anchor-links"
import { useLocale } from "../../utils/hooks/use-locale"
import { resolveLinkHref } from "../seo/canonical-tag/utils"
import * as styles from "./index.module.scss"
import { StructuredTextProps } from "./types"

export function StructuredTextBase({ body, renderBlock }: StructuredTextProps) {
  const locale = useLocale()
  return (
    <div className={styles.textContainer}>
      <StructuredText
        data={body}
        renderBlock={renderBlock}
        customNodeRules={[
          // Add ID values to heading tags for anchor links
          renderNodeRule(isHeading, ({ node, children, key }) => {
            const anchor = (toPlainText(node) || "")
              .toLowerCase()
              .replace(/ /g, "-")
              .replace(/[^\w-]+/g, "")

            return (
              <Header
                key={key}
                id={anchor}
                // From DATO we receive h2 and h3 headings, but need to use h3 and h4 headings.
                as={`h${node.level + 1}` as "h3" | "h4"}
                variant={(node.level + 1).toString() as "3" | "4"}
              >
                {children}
              </Header>
            )
          }),
          renderNodeRule(isLink, ({ node, children, key }) => {
            const attributes: { [key: string]: string } = { key }

            node.meta?.forEach(entry => {
              attributes[entry.id] = entry.value
            })

            if (node.url.startsWith("#")) {
              return (
                // eslint-disable-next-line react/forbid-elements -- Anchor link is not handled by UniversalLink
                <a
                  href={resolveLinkHref(node.url)}
                  {...attributes}
                  onClick={handleAnchorLink}
                >
                  {children}
                </a>
              )
            }
            return (
              <UniversalLink to={node.url} {...attributes}>
                {children}
              </UniversalLink>
            )
          }),
          datoParagraph("1"),
        ]}
        renderInlineRecord={record => datoInlineLink(record, locale)}
      />
    </div>
  )
}
